import React, { Component } from 'react';
import { bool, object, string } from 'prop-types';
import { FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';
import { propTypes } from '../../util/types';
import { obfuscatedCoordinates } from '../../util/maps';
import { Map } from '../../components';
import config from '../../config';

import css from './ListingPage.module.css';

class SectionMapMaybe extends Component {
  constructor(props) {
    super(props);
    this.state = { isStatic: true };
  }

  render() {
    const {
      className,
      rootClassName,
      geolocation,
      listingId,
      publicData,
      locationAlreadyApproximate,
    } = this.props;

    if (!geolocation) {
      return null;
    }

    const classes = classNames(rootClassName || css.sectionMap, className);
    const cacheKey = listingId ? `${listingId.uuid}_${geolocation.lat}_${geolocation.lng}` : null;
    const approximateMapsConfig = {
      ...config.maps,
      fuzzy: {
        ...config.maps.fuzzy,
        enabled: true,
        offset: Math.max(config.maps.fuzzy.offset || 0, 500),
        defaultZoomLevel: Math.min(config.maps.fuzzy.defaultZoomLevel || 13, 12),
      },
      customMarker: {
        ...config.maps.customMarker,
        enabled: false,
      },
    };
    const resolvedLocationAlreadyApproximate =
      typeof locationAlreadyApproximate === 'boolean'
        ? locationAlreadyApproximate
        : !!publicData?.locationApproximate;
    const obfuscatedCenter = resolvedLocationAlreadyApproximate
      ? geolocation
      : obfuscatedCoordinates(geolocation, cacheKey);
    const map = (
      <Map
        obfuscatedCenter={obfuscatedCenter}
        mapsConfig={approximateMapsConfig}
        useStaticMap={this.state.isStatic}
        zoom={approximateMapsConfig.fuzzy.defaultZoomLevel}
      />
    );

    return (
      <div className={classes}>
        <h2 className={css.locationTitle}>
          <FormattedMessage id="ListingPage.locationTitle" />
        </h2>
        <p className={css.locationHint}>
          <FormattedMessage id="ListingPage.locationHint" />
        </p>
        {this.state.isStatic ? (
          <button
            className={css.map}
            onClick={() => {
              this.setState({ isStatic: false });
            }}
          >
            {map}
          </button>
        ) : (
          <div className={css.map}>{map}</div>
        )}
      </div>
    );
  }
}

SectionMapMaybe.defaultProps = {
  rootClassName: null,
  className: null,
  geolocation: null,
  listingId: null,
  publicData: null,
  locationAlreadyApproximate: null,
};

SectionMapMaybe.propTypes = {
  rootClassName: string,
  className: string,
  geolocation: propTypes.latlng,
  listingId: propTypes.uuid,
  publicData: object,
  locationAlreadyApproximate: bool,
};

export default SectionMapMaybe;
